import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SessionContextService } from 'projects/packcert-web/src/app/context/session-context.service';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { SpinnerService } from 'shared-components';
import { EtiquetadoService } from '../../../../services/etiquetado.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as _timezones from 'projects/shared-components/src/lib/assets/timezone.json'


@Component({
    selector: 'app-etq-almacen-new-edit',
    templateUrl: './new-edit.component.html'
})
export class EtqAlmacenNewEditComponent implements OnInit, OnDestroy {

    private readonly destroy$ = new Subject<void>();
    public newEditForm: UntypedFormGroup;
    public showError = false;
    public deleteModal = false;
    public edicionModal = false;
    private _editable: boolean;
    private _toDelete: any;
    private _filters;
    public provincias = [];
    public municipios = [];
    public paises;
    public almacenId;
    public etiquetadorEdicion;
    public open;

    public disabledProvincias: Subject<boolean> = new Subject();
    public disabledMunicipios: Subject<boolean> = new Subject();
    public disabledTimezones: Subject<boolean> = new Subject();
    public disabledPaises: Subject<boolean> = new Subject();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.enable();
                this.disabledTimezones.next(false);
                this.disabledMunicipios.next(true);
                this.disabledProvincias.next(true);
                this.disabledPaises.next(false);
             }
        }
    }
    @Input() almacen?;
    @Input() almacenesList;
    @Input() etiquetadorId: number;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() close = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private _etiquetadoService: EtiquetadoService,
        private readonly _dataProvider: DataProvider,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService
    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            des: [{value: '', disabled: !this.editable }, Validators.required],
            direccion: [{value: '', disabled: !this.editable }, Validators.required],
            municipioId: [{ value: '', disabled: true }, Validators.required],
            latitud: [{ value: '', disabled: !this.editable }],
            longitud: [{ value: '', disabled: !this.editable }],
            msTimeZoneId: [{ value: '', disabled: !this.editable }],
            paisId: [{ value: '', disabled: !this.editable }, Validators.required],
            provinciaId: [{ value: '', disabled: true }, Validators.required]
        });

        const promises: Promise<any>[] = [];
        this._spinnerService.showSpinner();
        promises.push(
            this.getPaisesEtiquetador()
        );

        Promise.all(promises).then(
            () => {
                this.patchForm();
                return true;
            }, (error) => {
              console.log('Promise rejected with ' + JSON.stringify(error));
            }
        ).catch(e => console.log(e));

        this.newEditForm.get('paisId').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                this._filters = {
                    paisId: pais.id
                };
                this._spinnerService.showSpinner();
                this._etiquetadoService.getProvinciasByPaisId(this._filters).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.provincias = resp.lista;
                        if (this.almacen) {
                            this.newEditForm.get('provinciaId').patchValue(this.provincias.find(x => x.id === this.almacen.provinciaId));
                        }
                        if (this.newEditForm.get('paisId').enabled && this.newEditForm.get('paisId').value) {
                            this.disabledProvincias.next(false);
                            this.newEditForm.get('provinciaId').enable();
                            this.newEditForm.get('provinciaId').updateValueAndValidity();
                        }
                    } else {
                        this.disabledProvincias.next(true);
                        this.newEditForm.get('provinciaId').disable();
                    }
                });
            } else {
                this.disabledProvincias.next(true);
                this.newEditForm.get('provinciaId').disable();
                this.newEditForm.get('provinciaId').patchValue('');
                this.disabledMunicipios.next(true);
                this.newEditForm.get('municipioId').disable();
                this.newEditForm.get('municipioId').patchValue('');
            }
        });

        this.newEditForm.get('provinciaId').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((provincia) => {
            if (provincia) {
                this._filters = {
                    provinciaId: provincia.id
                };
                this._spinnerService.showSpinner();
                this._etiquetadoService.getMunicipiosByProvinciaId(this._filters).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then((resp) => {
                    if (resp.lista.length > 0) {
                        this.municipios = resp.lista;
                        if (this.almacen) {
                            this.newEditForm.get('municipioId').patchValue(this.municipios.find(x => x.id === this.almacen.municipioId));
                        }
                        if (this.newEditForm.get('provinciaId').enabled && this.newEditForm.get('provinciaId').value) {
                            this.disabledMunicipios.next(false);
                            this.newEditForm.get('municipioId').enable();
                        }
                    } else {
                        this.disabledMunicipios.next(true);
                        this.newEditForm.get('municipioId').disable();
                    }
                });
            } else {
                this.disabledMunicipios.next(true);
                this.newEditForm.get('municipioId').disable();
                this.newEditForm.get('municipioId').patchValue('');
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public patchForm() {
        if (this.almacen) {
            this.newEditForm.get('des').patchValue(this.almacen.des);
            this.newEditForm.get('direccion').patchValue(this.almacen.direccion);
            this.newEditForm.get('paisId').patchValue(this.paises.find(x => x.id === this.almacen.paisId));
            this.newEditForm.get('provinciaId').patchValue(this.provincias.find(x => x.id === this.almacen.provinciaId));
            this.newEditForm.get('municipioId').patchValue(this.provincias.find(x => x.id === this.almacen.provinciaId));
            this.newEditForm.get('msTimeZoneId').patchValue(this.timezones.find(x => x.id === this.almacen.msTimeZoneId));
            this.newEditForm.patchValue({
                longitud: this.almacen.geometria ? this.almacen.geometria.coordinates[0] : '',
                latitud: this.almacen.geometria ? this.almacen.geometria.coordinates[1] : ''
            });
        } else  {
            this.newEditForm.get('des').enable();
            this.newEditForm.get('direccion').enable();
            this.newEditForm.get('latitud').enable();
            this.newEditForm.get('longitud').enable();
            this.disabledTimezones.next(false);
            this.disabledPaises.next(false);
        }
    }

    public get timezones() {
        return this._dataProvider.timeZones;
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public getPaisesEtiquetador() {
        return new Promise((resolve, reject) => {
            this._spinnerService.showSpinner();
            this._etiquetadoService.getPaisesEtiquetador(this.etiquetadorId).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                this.paises = resp;
                setTimeout(resolve, 1);
            });
        });
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid) {
            this.newEditForm.patchValue({
                latitud: this.newEditForm.get('latitud').value.toString().replace(',', '.'),
                longitud: this.newEditForm.get('longitud').value.toString().replace(',', '.')
            });

            if (!this.almacen) {
                const newAlmacen = {
                    etiquetadorId: this.etiquetadorId,
                    des: this.newEditForm.get('des').value ? this.newEditForm.get('des').value : '',
                    direccion: this.newEditForm.get('direccion').value ? this.newEditForm.get('direccion').value : '',
                    geometria: {
                        type: 'Point',
                        coordinates:
                          [+this.newEditForm.get('longitud').value, +this.newEditForm.get('latitud').value]
                    },
                    municipioId: this.newEditForm.get('municipioId').value ? this.newEditForm.get('municipioId').value.id : '',
                    provinciaId: this.newEditForm.get('provinciaId').value ? this.newEditForm.get('provinciaId').value.id : '',
                    paisId: this.newEditForm.get('paisId').value ? this.newEditForm.get('paisId').value.id : '',
                    msTimeZoneId: this.newEditForm.get('msTimeZoneId').value ? this.newEditForm.get('msTimeZoneId').value.id : '',
                };
                this._etiquetadoService.createAlmacenEtiquetador(newAlmacen).toPromise().finally(() => {
                }).then(() => {
                  this.refresh.emit(true);
                  this.newEditForm.disable();
                  this.disabledMunicipios.next(true);
                  this.disabledProvincias.next(true);
                  this.disabledTimezones.next(true);
                  this.disabledPaises.next(true);
                  this.pushMessage.emit('global.success.itemCreated');
                });
            } else {
                const updateAlmacen = {
                    id: this.almacen.id,
                    etiquetadorId: this.etiquetadorId,
                    des: this.newEditForm.get('des').value ? this.newEditForm.get('des').value : '',
                    direccion: this.newEditForm.get('direccion').value ? this.newEditForm.get('direccion').value : '',
                    geometria: {
                        type: 'Point',
                        coordinates:
                          [+this.newEditForm.get('longitud').value, +this.newEditForm.get('latitud').value]
                    },
                    municipioId: this.newEditForm.get('municipioId').value ? this.newEditForm.get('municipioId').value.id : '',
                    provinciaId: this.newEditForm.get('provinciaId').value ? this.newEditForm.get('provinciaId').value.id : '',
                    paisId: this.newEditForm.get('paisId').value ? this.newEditForm.get('paisId').value.id : '',
                    msTimeZoneId: this.newEditForm.get('msTimeZoneId').value ? this.newEditForm.get('msTimeZoneId').value.id : '',
                };
                this._etiquetadoService.updateAlmacenEtiquetador(updateAlmacen).toPromise().finally(() => {
                }).then(() => {
                  this.refresh.emit(true);
                  this.newEditForm.disable();
                  this.disabledMunicipios.next(true);
                  this.disabledProvincias.next(true);
                  this.disabledTimezones.next(true);
                  this.disabledPaises.next(true);
                  this.pushMessage.emit('global.success.itemUpdated');
                });
            }
        } else {
            this.showError = true;
        }
    }

    public cancel() {
        if (!this.almacen) {
            this.close.emit(false);
        } else {
            this.editableChanged.emit();
            this.disabledTimezones.next(true);
            this.disabledPaises.next(true);
            this.disabledMunicipios.next(true);
            this.disabledProvincias.next(true);
            this.patchForm();
            this.newEditForm.disable({onlySelf: true, emitEvent: false});
        }
    }

    public edit(almacen) {
        this.newEditForm.enable();
        this.disabledTimezones.next(false);
        this.disabledPaises.next(false);
        this.editableChanged.emit(almacen);
    }

    public askDelete(almacen) {
        this._toDelete = almacen.id;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.deleteAlmacenEtiquetador(this._toDelete).toPromise().finally(() => {
        }).then(() => {
          this.closeModal();
          this.refresh.emit(true);
          this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    public closeModal() {
        this.deleteModal = false;
        this._toDelete = '';
    }

    private checkForm() {
        const direccionValue = this.newEditForm.get('direccion')?.value;
        if (!direccionValue || direccionValue.trim() === '') this.newEditForm.get('direccion').patchValue('');
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }

    public openAppEdicion(almacen) {
        this.edicionModal = true;
        this.almacenId = almacen.id;
        this.etiquetadorEdicion = almacen.etiquetadorId;
        almacen.geometria ? this.open = 1 : this.open = 2;
    }

    public closeMap() {
        this.edicionModal = false;
        this.almacenId = null;
        this.etiquetadorEdicion = null;
        this.open = null;
        this.refresh.emit(true);
    }
}
